/* eslint-disable no-console */
import { HttpException } from '@app/lib/http/client/exception/HttpException';
import { isHttpException } from '@app/lib/http/util/isHttpException';
import { LoggerInterface } from '@app/lib/logger/Contracts/LoggerInterface';

export class ConsoleLogger implements LoggerInterface {
    logException(error: Error): void {
        console.info(`${error.constructor.name} was thrown:`, error.message);

        if (error instanceof HttpException || isHttpException(error)) {
            this.logMessage(`Request URL: ${error.response?.url}`);
            this.logJson(error.response?.data ?? {});
        }
    }

    logJson(object: object): void {
        console.log('JSON:', `\n${JSON.stringify(object, null, 2)}`);
    }

    logMessage(message: string): void {
        console.log(message);
    }
}
